import { render } from "./SocialPoster.vue?vue&type=template&id=6928e7d9"
import script from "./SocialPoster.vue?vue&type=script&lang=js"
export * from "./SocialPoster.vue?vue&type=script&lang=js"

import "./SocialPoster.vue?vue&type=style&index=0&id=6928e7d9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__